<ng-container *ngIf="{ isMobileWebView: isMobileWebView$ | async } as vm">
  <page-title text="Support | BitOasis" i18n-text="@@pageTitle.support"></page-title>
  <site-layout class="push narrow" [hideHeader]="vm.isMobileWebView">
    <div [ngSwitch]="isTypeCopperateOrVipValue">
      <h2 *ngSwitchCase="true" class="text-header text-bold text-center mb-2" i18n="@@front.support.enquiry.title">
        Submit an Enquiry
      </h2>
      <h2 *ngSwitchDefault class="text-header text-bold text-center mb-2" i18n="@@front.support.title">
        Submit a Support Ticket
      </h2>
    </div>
    <p class="text-lg text-center" i18n="@@front.support.subtitle">
      How can we help you?
    </p>
    <div class="p-3"></div>

    <page-notification location="SUPPORT"></page-notification>
    <support-form [type]="type" [title]="title" [isTypeCopperateOrVip]="isTypeCopperateOrVipValue"></support-form>

    <p *ngIf="!vm.isMobileWebView" class="m-3 text-center" i18n="@@front.support.knowledgeCenter">
      Do you have questions? Check our
      <a [href]="isAr ? links.support.ar : links.support.en" target="_blank" rel="noopener">
        Support
      </a>
    </p>

    <!-- <ng-container *ngIf="vip">
      <h3 class="text-lg text-center pt-4" i18n="@@front.support.vipSupportCardTitle">For any additional help</h3>
      <contact-card></contact-card>
    </ng-container> -->
  </site-layout>
  <site-footer *ngIf="!vm.isMobileWebView"></site-footer>
</ng-container>